import { MonitoringPolicyResponseModelV1 } from "@/api";

interface ConditionTypes {
  [key: string]: { name: string; id: string }[];
}
export const conditionTypes: ConditionTypes = {
  "1": [], // Principal type ALL
  // Principal type User
  "2": [
    { name: "All", id: "3" },
    { name: "Specific list ", id: "1" },
  ],
  // Principal type Service Account
  "3": [
    { name: "In whitelist", id: "1" },
    { name: "Not In whitelist", id: "2" },
    { name: "Specific list", id: "1" },
  ],
  // Principal type Group
  "4": [
    { name: "All Groups ", id: "3" },
    { name: "Custom ", id: "1" },
  ],
  // Principal type Group User_App
  "5": [
    { name: "In whitelist", id: "1" },
    { name: "Not In whitelist", id: "2" },
  ],
  // Principal type Group User_IP
  "6": [
    { name: "In whitelist", id: "1" },
    { name: "Not In whitelist", id: "2" },
  ],
};

export const ResourceConditions = [
  { name: "Classified as", id: "1" },
  { name: "Named as", id: "2" },
  { name: "None", id: "" },
];

export const getSelectResourceCondition = (
  data: MonitoringPolicyResponseModelV1,
) => {
  return data.dataClassification?.length
    ? ResourceConditions[0]
    : data.resourceType?.value?.length && data.resourceType?.value[0].length > 0
      ? ResourceConditions[1]
      : ResourceConditions[2];
};
export const MatchingCondition = {
  inUser: 'User "<username>"',
  inUserApp: 'User_App "<application>"',
  inUserIp: 'User_IP "<ipAddress>"',
  notInUser: 'Unauthorized User "<username>"',
  notInUserApp: 'Unauthorized User_App "<application>"',
  notInUserIp: 'Unauthorized User_IP "<ipAddress>"',
  allPrincipalResource: "NA",
  allPrincipal: 'Table "<objectName>" classified as "<classification>"',
  allResource:
    'was used to access all resource classified as "<classification>"',
  principalResource:
    'was used to access Table "<objectName>" classified as "<classification>"',
};

const [classification, names] = ResourceConditions;
// conditions types are defined based on  https://trustlogix.atlassian.net/browse/TRUST-2018
export const ResourceConditionsTypes = [
  {
    id: "9",
    name: "Account",
    conditions: [],
  },
  {
    id: "10",
    name: "Privilege",
    conditions: [names],
  },
  {
    id: "11",
    name: "Role",
    conditions: [names],
  },
  {
    id: "2",
    name: "Table",
    conditions: [names, classification],
  },
  {
    id: "3",
    name: "Schema",
    conditions: [names, classification],
  },
  {
    id: "5",
    name: "View",
    conditions: [names, classification],
  },
  {
    id: "6",
    name: "Database",
    conditions: [names, classification],
  },
];

export const getResourceConditionsTypes = (id: string) =>
  ResourceConditionsTypes.find(item => item.id === id)?.conditions || [
    classification,
    names,
  ];

export type ConditionsType = keyof typeof conditionTypes;

export const DataSizeTypes = [
  { id: "KB", name: "KB" },
  { id: "MB", name: "MB" },
  { id: "GB", name: "GB" },
  { id: "TB", name: "TB" },
];

export const MuteDurationPermanently = {
  id: "PERMANENTLY",
  name: "Permanently",
};
export const MuteDurationOptions = [
  {
    id: "30D",
    name: "30 Days",
  },
  {
    id: "90D",
    name: "90 Days",
  },
  MuteDurationPermanently,
];

export const QUERY_PLACEHOLDERS: Record<string, string> = {
  sqlserver: `e.g. SELECT TOP 5 event_time, server_principal_name, server_instance_name, client_ip, application_name, statement 
FROM TLX_POLICY_DB.TLX_ROW_POLICY.tlx_sqlserver_audits 
WHERE class_type = 'LX' and succeeded = 0
ORDER BY event_time desc;`,
  mysql: `e.g. SELECT login_ip,login_user,login_host,client_name from TLX_POLICY_DB.tlx_audit_events where login_user = 'USER' limit 20;`,
  oracle: `e.g. SELECT EVENT_TIMESTAMP,OS_USERNAME,DBUSERNAME,AUTHENTICATION_TYPE,
USERHOST,CLIENT_PROGRAM_NAME,SYSTEM_PRIVILEGE_USED
FROM audsys.unified_audit_trail WHERE ACTION_NAME = 'LOGON' ORDER BY event_timestamp DESC
FETCH FIRST 20 ROWS ONLY;`,
  default: `e.g. SELECT TABLE_NAME,ACTIVE_BYTES,TIME_TRAVEL_BYTES
FROM SNOWFLAKE.ACCOUNT_USAGE.TABLE_STORAGE_METRICS
WHERE ACTIVE_BYTES > 10000 and TIME_TRAVEL_BYTES > ACTIVE_BYTES
LIMIT 1000;`,
};
